import Controller from '@ember/controller';
import { service } from '@ember/service';
import type PartnerDashboardsService from 'tio-employee/services/partner-dashboards';

export default class AuthenticatedAdminReportsIndexController extends Controller {
  @service declare partnerDashboards: PartnerDashboardsService;
}
